module.exports = __webpack_public_path__ + "img/digitalWave3.09605c95.jpeg";